import React from "react";
import {
  SEO,
  PageLayout,
  Image,
  Content,
  SocialMedia,
  PaginatedGrid,
  componentIterator,
  Review,
} from "@bluefin/components";
import { Grid, Header } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class AboutPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout hero={false} subfooter={false} className={"about-page"}>
          <Image
            src={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "HeroElement",
              componentIdentifier: "background",
              numToSelect: 1,
            })}
            className={"page-background-image"}
            background={true}
          >
            <div />
          </Image>
          <Grid
            className={"about-content-container"}
            stackable={true}
            className={"home-content"}
            textAlign={"center"}
          >
            <Grid.Column width={6}>
              <Content className={"about-content"} textAlign={"left"}>
                <Content.Image
                  background={true}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "HeroElement",
                    numToSelect: 1,
                  })}
                />
                <Content.Markup
                  width={16}
                  isMarkdown={false}
                  content={
                    <Grid.Column className={"custom-container"}>
                      <SocialMedia
                        socialMediaValues={fishermanBusiness.socialMedia}
                        buttonType={"rect"}
                        centerHeader={false}
                        colors={"secondary"}
                        groupButtons={false}
                        groupVertically={false}
                        inverted={true}
                        labelPosition={"free"}
                        showLabels={false}
                      />
                      <p>
                        We would like to thank you for visiting Alley Cat
                        Lounge. We realize you have hundreds of choices, and we
                        are thrilled that you have picked our little basement
                        bar.
                      </p>
                      <p>
                        The act of coming together to share drink and
                        companionship is a beautiful human tradition – one that
                        has endured periods of intense hardships such as
                        economic calamity and war.
                      </p>
                      <p>
                        Savannah has welcomed people from afar for generations
                        and we are proud to be part of that continuing tradition
                        of Southern hospitality
                      </p>
                      <p>
                        At Alley Cat Lounge, we strive to bring you the highest
                        quality and freshest ingredients possible in everything
                        we serve. Our goal is to also put as much emphasis on
                        the hospitality and interpersonal relationships as our
                        distillers, brewers, and vintners have put into their
                        products. We cherish and appreciate the history of the
                        craft and honor those who have blazed the trail we walk
                        on.
                      </p>
                      <p>
                        We like to say, “we do not serve drinks – we serve
                        people, and we serve experiences.” The drinks, décor,
                        music, and location are merely just tools to help enjoy
                        this moment in time and these future memories. Please
                        relax, unwind, be yourself, meet old friend or make new
                        ones, share the pleasures and heartaches of life,
                        celebrate achievements, regroup after failures, recharge
                        your soul, and prepare for another day.
                      </p>
                      <p>
                        Our only request is that you walk up those stairs
                        happier and more satisfied than when you walked down
                        them!
                      </p>
                      <p>Love and Peace</p>
                    </Grid.Column>
                  }
                />
              </Content>
            </Grid.Column>
            <Grid.Column
              className={"about-image-gallery-container"}
              width={10}
              textAlign={"left"}
            >
              <PaginatedGrid
                rows={3}
                className={"image-gallery"}
                mobile={{ columns: 2, rows: 4, stackable: false }}
                items={componentIterator({
                  iterator: getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "ImageCollection",
                  }),
                  component: (
                    <Image
                      background={true}
                      style={{ paddingTop: "100%", height: "100%" }}
                    />
                  ),
                  propMap: { src: "__all__" },
                })}
              />
              <Grid.Column>
                <Header as={"h2"}>Reviews</Header>
                <PaginatedGrid
                  rows={2}
                  columns={2}
                  className={"reviews"}
                  tight={true}
                  items={componentIterator({
                    iterator: fishermanBusiness.reviews,
                    component: <Review as={"horizontalItem"} charLimit={360} />,
                    propMap: { author: "author", text: "text" },
                  })}
                />
              </Grid.Column>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      socialMedia {
        link
        type
      }
      reviews {
        author
        text
        link
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "About" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
